import React, { useEffect, useContext, useState } from 'react'
import styled from "styled-components"
import { navigate, withPrefix } from "gatsby";
import { JourneyContext } from "../context/journeyContext"
import {salesConfidentialReportPdf, awsImageUrl} from "../../services/apiservice.js"


export default function ThankYou(props) {
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [b64Pdf,setB64Pdf] = useState();

  useEffect(()=>{
      let payload = {
          id: journeyState.journeyId
        }
      salesConfidentialReportPdf(payload).then(res=>{
          console.log(res);
          setJourneyState(prev=>{
              return{
                  ...prev,
                  salesConfidentialReportLink : `${journeyState.applicationNo}/${res?.pdfPath?.fileName}`,
              }
          })
      }).catch(err=>{
          console.log(err);
      })
  },[])

  const onItemClick = async()=>{
      const fileName = journeyState.salesConfidentialReportLink;
      if(b64Pdf){
        // For Other Browsers
        const linkSource = "data:application/pdf;base64," + b64Pdf
        const link = document.createElement("a")
        link.href = linkSource
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        link.remove()
  
        window.addEventListener(
          "focus",
          function () {
            URL.revokeObjectURL(link.href)
          },
          { once: true }
        )
      }else{
        const res = await awsImageUrl(journeyState.salesConfidentialReportLink, journeyState.applicationNo);   
        setB64Pdf(res.data);
        // For Other Browsers
        const linkSource = "data:application/pdf;base64," + res.data
        const link = document.createElement("a")
        link.href = linkSource
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        link.remove()
  
        window.addEventListener(
          "focus",
          function () {
            URL.revokeObjectURL(link.href)
          },
          { once: true }
        )
      }

    }
    return (
        <div>
                <div class="canara-Pos-red-border">
                    <div class="canara-pos-success-content"> 
                    {
                          <img src={withPrefix(`/images/success-icon.png`)} />
                    }
                        <h2>Congratulations.</h2>
                        <p>Sales Confidential Report submitted successfully</p>
                        <p className="app-medical-recomended">
                        Application Number: {journeyState.applicationNo}
                        </p>
                        <div className="download-receipt-structure download-receipt-structure-2" style={{background: `${journeyState.channel === "A" ? "#3e505d" : journeyState.channel === "B" ? "#a20a3a" : journeyState.channel === "C" ? "#0ab0ef" : "#eb7f25"}`}}> {/*var(--lumiq-card-bg)*/}
                        {" "}
                        <a
                          style={{display:"flex", justifyContent:"center", color: "#fff", textDecoration: "none", cursor: "pointer" }}
                          aria-hidden="true"
                          // href={process.env.AWS_IMAGE_URL + journeyState.proposalFormLink} target="_blank"
                          onClick={onItemClick}
                        >
                          <div className="download-ap-receipt-stucture" style={{
                            width : "100%"
                          }}>
                            {" "}
                            <img src={withPrefix("/images/download-receipt.png")} />
                            <p><a style={{color:"white"}} 
                                target="_blank">
                              Click to
                              <br />
                              Download form
                              </a>
                            </p>
                          </div>
                        </a>{" "}
                      </div>
                    </div>
                </div>
        </div>
    )
}